import { ChildProcessWithoutNullStreams } from "child_process";
import { CommApiInstance } from "Utils/CommApiInstance";




const MembQnaLstApi= async (
    GameSvcCd:string,
    nowPageNo:number,
    srch:string,
) => {
    return await CommApiInstance.post(`memb/qna/${GameSvcCd}/qna_lst?page=${nowPageNo}&srch=${srch}`,{
        apiBody:{

        },
    })
    .then((Resp) => Resp.data);
}
export default MembQnaLstApi;